import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import styles from '../../../../components/Display/Wrapper.module.scss';
import DocumentItem from '../../common/document/DocumentItem';

function JobOfferDetail({
  joboffer,
  handleUpdateJobOffer,
  handleDelete,
  handleUpdateFile,
  handleDeleteFile,
  handleCreateFile
}) {
  const updateJobOfferActions = [
    {
      onClick: handleUpdateJobOffer,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (joboffer) => {
    confirmDialog({
      message: "Êtes-vous sûr de vouloir supprimer cette Offre d'emploi ?",
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(joboffer)
    });
  };

  const confirmDocumentDeletion = (document) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteFile(document)
    });
  };

  const newFileActions = [
    {
      onClick: handleCreateFile,
      label: 'Ajouter un fichier',
      icon: 'pi-plus'
    }
  ];

  const updateFileActions = [
    {
      onClick: () => handleUpdateFile(joboffer.file),
      label: 'Modifier le fichier',
      icon: 'pi-pencil'
    }
  ];

  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations Générales" actions={updateJobOfferActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={joboffer.title} large />
          <Data key="Nom de la structure" label={'Structure'} value={joboffer.company} large />
          <Data key="Ville" label={'Ville'} value={joboffer?.city?.city} large />
        </div>
        <MultiLineData key="resume" label={'Resumé'} value={joboffer.resume} large asHtml />
      </Section>
      <div className="flex flex-wrap gap-5">
        <Section
          label="Fichier téléchargeable"
          actions={joboffer.file ? updateFileActions : newFileActions}>
          <div className="flex flex-wrap gap-3">
            {joboffer.file && (
              <DocumentItem
                document={joboffer.file}
                onDelete={() => confirmDocumentDeletion(joboffer.file)}
                onUpdate={() => handleUpdateFile(joboffer.file)}
                key="file"
                label={'Fichier'}
              />
            )}
          </div>
        </Section>{' '}
      </div>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'offre d\'emploi"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(joboffer)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default JobOfferDetail;
